import { marketActions } from '../actions';

export default function markets ( initialState = {}, action ) {
    const newState = { ...initialState };

    switch ( action.type ) {
        case marketActions.SET_PROFILE_MARKETS: return generalMarketsReducer( newState, action );
        case marketActions.GENERAL_MARKETS_SUCCESS: return generalMarketsReducer( newState, action );
        default: return newState;
    }
}

function generalMarketsReducer ( newState, action ) {
    delete action.type;
    return  Object.assign( newState, { ...action } );
}


// WEBPACK FOOTER //
// src/client/components/site/features/profile/reducers/markets.js